import { IErrorHandling, OnboardingFormFields } from '@Types/index';

export const EmailErrorMap = {
  EMAIL_ALREADY_EXISTS: 4041,
  INVALID_EMAIL_FORMAT: 4024,
  AUTHORIZED_USER_EMAIL_ALREADY_EXISTS: 90225,
  EMAIL_CHANGE_IS_NOT_ALLOWED: 41195,
  UBO_EMAIL_ALREADY_EXISTS: 41196,
  EMAIL_ALREADY_EXISTS_AS_AUTHORIZED_USER: 50729,
};

export const EmailErrorMapObject = new Map<number, IErrorHandling>([
  [
    EmailErrorMap.EMAIL_ALREADY_EXISTS,
    {
      errorCode: EmailErrorMap.EMAIL_ALREADY_EXISTS,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.EMAIL,
      callBack: () => {},
    },
  ],
  [
    EmailErrorMap.INVALID_EMAIL_FORMAT,
    {
      errorCode: EmailErrorMap.INVALID_EMAIL_FORMAT,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.EMAIL,
      callBack: () => {},
    },
  ],
  [
    EmailErrorMap.AUTHORIZED_USER_EMAIL_ALREADY_EXISTS,
    {
      errorCode: EmailErrorMap.AUTHORIZED_USER_EMAIL_ALREADY_EXISTS,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.EMAIL,
      callBack: () => {},
    },
  ],
  [
    EmailErrorMap.EMAIL_CHANGE_IS_NOT_ALLOWED,
    {
      errorCode: EmailErrorMap.EMAIL_CHANGE_IS_NOT_ALLOWED,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.EMAIL,
      callBack: () => {},
    },
  ],
  [
    EmailErrorMap.UBO_EMAIL_ALREADY_EXISTS,
    {
      errorCode: EmailErrorMap.UBO_EMAIL_ALREADY_EXISTS,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.EMAIL,
      callBack: () => {},
    },
  ],
  [
    EmailErrorMap.EMAIL_ALREADY_EXISTS_AS_AUTHORIZED_USER,
    {
      errorCode: EmailErrorMap.EMAIL_ALREADY_EXISTS_AS_AUTHORIZED_USER,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.EMAIL,
      callBack: () => {},
    },
  ],

]);
